export const normalizeForSearch = (value) => {
  const raw = String(value ?? "");
  try {
    return raw
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  } catch {
    return raw.toLowerCase();
  }
};

export const countSearchLetters = (value) => {
  const normalized = normalizeForSearch(value);
  const matches = normalized.match(/[a-z]/g);
  return matches ? matches.length : 0;
};

export const hasSearchLetters = (value) => countSearchLetters(value) > 0;
